<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-70">
      <div class="md-layout">

        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25" v-for="(box, index) in this.boxes"
          :key="index">
          <div v-on:click="setFilter(box.collectionType, box.lastDays, box)" v-if="box && box.active">
            <router-link to="#">
              <stats-card>
                <template slot="header">
                  <div class="card-icon smaller">
                    <md-icon>{{ box.icon }}</md-icon>
                  </div>
                  <p class="category header-text">{{ box.name }}</p>

                  <span v-if="box.count > 0">
                    +
                    <animated-number :value="box.count"></animated-number>
                  </span>
                  <span v-else>0</span>
                </template>

                <template slot="footer">
                  <div class="stats">
                    <md-icon>date_range</md-icon>
                    <span v-if="box.lastDays">
                      Last
                      <animated-number :value="box.lastDays"></animated-number>&nbsp;Days
                    </span>
                  </div>
                </template>
              </stats-card>
            </router-link>
          </div>
        </div>

      </div>
      <md-card>
        <md-card-content>
          <carousel v-if="this.$store.state.carousels.length > 0" :autoplay="true" :loop="true" :autoplayTimeout="5000"
            :perPage="1" :autoplayHoverPause="true">
            <slide v-for="(carousel, index) in this.$store.state.carousels" :key="index">
              <div v-if="carousel.clickableSlideBox" class="slide-box">
                <a v-if="carousel.mediaFilter" href="#" @click.prevent="
                  setActiveFilter(JSON.parse(carousel.mediaFilter))
                  ">
                  <img :src="carousel.mediaUrl" />
                  <div v-if="carousel.title" class="title-box">
                    {{ carousel.title }}
                  </div>
                </a>
                <a v-else :href="carousel.mediaFile" target="blank">
                  <img :src="carousel.mediaUrl" />
                  <div v-if="carousel.title" class="title-box">
                    {{ carousel.title }}
                  </div>
                </a>
              </div>
              <div v-else class="slide-box">
                <img :src="carousel.mediaUrl" />
                <div v-if="carousel.title" class="title-box">
                  {{ carousel.title }}
                </div>
                <div class="link-container">
                  <div v-if="carousel.link1Title" class="link-box">
                    <md-button v-if="carousel.mediaFile" class="md-simple md-sm filter-button">
                      <a :href="carousel.mediaFile" target="blank">
                        <span>{{ carousel.link1Title }}</span>
                      </a>
                    </md-button>
                    <md-button v-else class="md-simple md-sm filter-button" v-on:click="
                      setActiveFilter(JSON.parse(carousel.link1Filter))
                      ">
                      <span>{{ carousel.link1Title }}</span>
                    </md-button>
                  </div>
                  <div v-if="carousel.link2Title" class="link-box">
                    <md-button v-on:click="
                      setActiveFilter(JSON.parse(carousel.link2Filter))
                      " class="md-simple md-sm filter-button">
                      <span>{{ carousel.link2Title }}</span>
                    </md-button>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30">
      <md-card v-if="this.$store.state.pregeneratedCarts.length != 0">
        <md-card-header class="md-card-header-icon">
          <div class="card-icon larger">
            <md-icon>cloud_download</md-icon>
          </div>
          <h4 class="title">Pregenerated packages</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout-item md-medium-size-50">
            <div v-if="this.$store.state.pregeneratedCarts.length == 0" style="margin-bottom: 8px">
              <span class="filter-text">No pregenerated packages</span>
            </div>
            <div v-for="(download, index) in this.$store.state.pregeneratedCarts" :key="index">
              <md-button v-on:click="downloadFile(download.url)" class="md-simple md-sm filter-button">
                <md-icon>archive</md-icon>
                <span>{{ download.name }}</span>
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card v-if="showSharedCarts">
        <md-card-header class="md-card-header-icon">
          <div class="card-icon larger">
            <md-icon>shop_two</md-icon>
          </div>
          <h4 class="title">Shared carts</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout-item md-medium-size-50">
            <div v-for="(cart, index) in this.$store.state.cartsSharedWithMe" :key="index + '-shared-cart'"
              class="change-pz">
              <a :href="'#/cart/' + cart.id + '/1'">
                <md-icon>keyboard_arrow_right</md-icon>
                <span>{{ cart.name }}</span>
              </a>
            </div>
            <div v-for="(cart, index) in this.$store.state.mySharedCarts" :key="index + '-admin-cart'"
              class="change-pz">
              <a :href="'#/cart/' + cart.id + '/1'">
                <md-icon>keyboard_arrow_right</md-icon>
                <span v-if="!cart.expired">{{ cart.name }}</span>
                <span v-if="cart.expired" style="color: #999999;  font-weight: 300;">{{ cart.name }} - Expired</span>
              </a>
              <div style="float: right">
                <a v-on:click="showEditCartModal(cart.id)">
                  <md-icon>edit</md-icon>
                </a>
                <a v-on:click="showDeleteCartModal(cart.id)">
                  <md-icon>delete</md-icon>
                </a>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-header class="md-card-header-icon">
          <div class="card-icon larger">
            <md-icon>update</md-icon>
          </div>
          <h4 class="title">Activities</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout-item md-medium-size-50">
            <h4 class="title">Favorite Filters</h4>

            <div v-if="this.$store.state.user.favoriteFilters.length == 0" style="margin-bottom: 8px">
              <span class="filter-text">No favorite filters</span>
            </div>
            <div v-for="(filters, index) in this.$store.state.user.favoriteFilters" :key="index">
              <md-button v-on:click="setActiveFilter(filters.filters)" class="md-simple md-sm filter-button">
                <md-icon>favorite</md-icon>
                <span v-for="(filter, index) in filters.filters" :key="index" class="filter-text">
                  {{ filter.facet.displayName || filter.facet.value }}
                  <span v-if="
                    filters.filters.indexOf(filter) <
                    filters.filters.length - 1
                  ">></span>
                </span>
              </md-button>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-50">
            <h4 class="title">Recent Downloads</h4>
            <div v-if="this.$store.state.downloads.length == 0" style="margin-bottom: 8px">
              <span class="filter-text">No recent downloads</span>
            </div>
            <div v-for="(download, index) in this.$store.state.downloads.slice(0, 10)" :key="index">
              <md-button v-on:click="downloadFile(download.url)" class="md-simple md-sm filter-button">
                <md-icon>archive</md-icon>
                <span>{{ download.name }}</span>
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card v-if="this.$store.state.environments.length > 0">
        <md-card-header class="md-card-header-icon">
          <div class="card-icon larger">
            <md-icon>home</md-icon>
          </div>
          <h4 class="title">Change Partner Zone</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout-item md-medium-size-50">
            <div v-for="(environment, index) in this.$store.state.environments" :key="index + '-environment'"
              class="change-pz">
              <a v-on:click="setActiveEnvironment(environment.id)">
                <md-icon>keyboard_arrow_right</md-icon>
                <span>{{ environment.name }}</span>
              </a>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <div class="feedback-button-container" @click="toggleFeedback">
      <div class="feedback-button-rotated">Feedback</div>
    </div>
    <transition name="slide">
      <div class="feedback-container" v-if="showFeedbackForm">
        <div class="feedback-logo">
          <!-- Header -->

          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="toggleFeedback">
            <md-icon>clear</md-icon>
          </md-button>
        </div>
        <div>
          <!-- Body -->
          <div style="text-align: center">
            <p>
              Your feedback is greatly appreciated and helps us improve your
              site experience.
            </p>
          </div>

          <div style="text-align: center">
            <div>
              <h4>What is your opinion of this site</h4>
            </div>
            <div class="md-group">
              <div :class="getFaceClasses('very-unhappy')" v-on:click="setSelectedFace('very-unhappy')"
                title="Very unhappy">
                <md-icon>sentiment_very_dissatisfied</md-icon>
              </div>
              <div :class="getFaceClasses('unhappy')" v-on:click="setSelectedFace('unhappy')" title="Unhappy">
                <md-icon>sentiment_dissatisfied</md-icon>
              </div>
              <div :class="getFaceClasses('happy')" v-on:click="setSelectedFace('happy')" title="Happy">
                <md-icon>sentiment_satisfied</md-icon>
              </div>
              <div :class="getFaceClasses('very-happy')" v-on:click="setSelectedFace('very-happy')" title="Very happy">
                <md-icon>sentiment_satisfied_alt</md-icon>
              </div>
            </div>
          </div>

          <div style="text-align: center">
            <div>
              <h5>Please select your feedback category below</h5>
            </div>
            <div class="feedback-category">
              <md-button v-on:click="setSelectedCategory('suggestion')"
                :class="getCategoryClasses('suggestion')">Suggestion
              </md-button>
              <md-button v-on:click="setSelectedCategory('improvement')"
                :class="getCategoryClasses('improvement')">Improvement
              </md-button>
              <md-button v-on:click="setSelectedCategory('compliment')"
                :class="getCategoryClasses('compliment')">Compliment
              </md-button>
            </div>
            <div>
              <h5>Please leave your feedback below</h5>
            </div>
            <textarea v-model="feedbackText" class="feedback-input"></textarea>
          </div>
        </div>
        <div style="text-align: right">
          <!-- Footer -->
          <md-button class="feedback-button-filled" @click="sendFeedback">Send
          </md-button>
        </div>
      </div>
    </transition>
    <modal v-if="shareCartModal" @close="editCartModalHide">
      <template slot="header">
        <h4 class="modal-title">Edit cart</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="editCartModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <shared-cart-details-form :shareCartModel="cartModel" :isEditMode="true" />
      </template>

      <template slot="footer">
        <md-button @click="editCartModalHide" class="md-simple">Close</md-button>
        <md-button style="margin-left: 8px" class="md-primary" @click="saveCart">Save</md-button>
      </template>
    </modal>
    <modal v-if="deleteCartModal" @close="deleteCartModalHide" class="delete-modal">
      <template slot="header">
        <h4 class="modal-title">Confirm cart deletion</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="deleteCartModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        Are you sure you want to delete cart "{{ cartModel.name }}"?
      </template>

      <template slot="footer">
        <md-button @click="deleteCartModalHide">Cancel</md-button>
        <md-button style="margin-left: 8px" class="md-primary" @click="deleteCart(cartModel.id)">Delete</md-button>
      </template>
    </modal>
  </div>
</template>

<script>
import SearchService from "@/services/SearchService";
import UserService from "@/services/UserService";
import FeedbackService from "@/services/FeedbackService";
import CartService from "@/services/CartService";
import EnvironmentService from "@/services/EnvironmentService";
import store from "../../store";
import $ from "jquery";
import { StatsCard, AnimatedNumber, Modal } from "@/components";
import { SharedCartDetailsForm } from "@/components";
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    StatsCard,
    AnimatedNumber,
    Carousel,
    Slide,
    Modal,
    SharedCartDetailsForm,
  },
  data() {
    return {
      seq2: 0,
      latestUpdates: 0,
      showFeedbackForm: false,
      selectedFace: "",
      selectedCategory: "",
      feedbackText: "",
      shareCartModal: false,
      deleteCartModal: false,
      cartModel: {
        id: "",
        name: "",
        message: "",
        expirationDate: new Date().toISOString().slice(0, 10),
        notifyUsers: false,
        sharedWithUsers: [],
        environmentId: ""
      },
      boxes: []
    };
  },
  mounted() {
    const vueDashboard = this;
    if (this.activeEnvironment.id)
      this.getDashboardBoxes(this.activeEnvironment.id)
        .then(function () {
          vueDashboard.boxes.forEach(box => vueDashboard.refreshCountForBox(box));
        });

    this.$store.dispatch("loadUserSharedCarts");
  },
  computed: {
    activeEnvironment: function () {
      return store.state.activeEnvironment;
    },
    showSharedCarts() {
      return this.$store.state.mySharedCarts.length > 0 || this.$store.state.cartsSharedWithMe.length > 0;
    }
  },
  watch: {
    activeEnvironment: function (newActiveEnvironment) {
      const vueDashboard = this;
      this.getDashboardBoxes(newActiveEnvironment.id)
        .then(function () {
          vueDashboard.boxes.forEach(box => vueDashboard.refreshCountForBox(box));
        })
    }
  },
  methods: {
    async setActiveEnvironment(environment) {
      await UserService.SetUserEnvironment(environment);

      this.$store.commit("clearCart");
      this.$store.commit("clearFilters");
      this.$store.commit("setSearchString", "");
      this.$store.commit("setSearchList", "");
      this.$store.commit("setSearchSinceUtc", null);
      this.$store.commit("setActiveEnvironment", environment);

      location.reload();
    },
    toggleFeedback() {
      this.showFeedbackForm = !this.showFeedbackForm;

      $(".feedback-button-container").toggle(600);
    },
    async sendFeedback() {
      if (this.selectedFace == "" && this.feedbackText == "") {
        return;
      }
      await FeedbackService.SendFeedback({
        face: this.selectedFace,
        category: this.selectedCategory,
        text: this.feedbackText,
      });

      this.selectedCategory = "";
      this.feedbackText = "";
      this.selectedFace = "";
      this.notifyVue("Thank you for the feedback!");
      this.toggleFeedback();
    },

    getCategoryClasses(category) {
      if (this.selectedCategory == category) {
        return "md-sm feedback-button-selected";
      }
      return "md-sm feedback-button";
    },
    setSelectedCategory(category) {
      this.selectedCategory = category;
    },
    getFaceClasses(face) {
      if (this.selectedFace == face) {
        return "feedback-face feedback-selected-face";
      }
      return "feedback-face feedback-unselected-face";
    },
    setSelectedFace(face) {
      this.selectedFace = face;
    },
    setFilter(collectionType, daysBefore, box) {
      this.$store.commit("clearFilters");
      this.$store.commit("setSearchString", "");
      this.$store.commit("setSearchList", "");
      this.$store.commit("setSearchSinceUtc", this.getSinceDate(daysBefore));

      if(box.filter){
        let filter = JSON.parse(box.filter);
        this.$store.commit("setFilters", filter)
      }
      else {
        const filterNamePrefix = daysBefore == undefined ? "Type: " : "New: ";
        let collection = this.$store.state.activeEnvironment.collections.filter(item => item.type.toLowerCase() === collectionType.toLowerCase())[0];

        this.$store.commit("addFilter", {
          name: filterNamePrefix + collection.displayName,
          facet: { key: "@type", value: collectionType, displayName: box.filterDisplayName || collection.displayName },
        });
      }

      this.$router.push("content");
    },
    downloadFile(url) {
      window.open(url, "_self");
    },
    setActiveFilter(filters) {
      this.$store.commit("setFilters", JSON.parse(JSON.stringify(filters)));
      this.$router.push("content");
    },
    getSinceDate: function (daysBefore) {
      if (!daysBefore) return null;
      const since = new Date(Date.now() - daysBefore * 24 * 60 * 60 * 1000);
      return since.toISOString();
    },
    async refreshCountForBox(box) {
      const since = this.getSinceDate(box.lastDays);
      const filter = box.filter;
      box.count = await SearchService.Count(box.collectionType, since, filter);
    },
    async getLatestUpdateCount() {
      const response = await SearchService.GetLatestUpdatesCount();

      this.latestUpdates = response.data.result;
    },
    async getDashboardBoxes(id) {
      if (id) {
        const response = await EnvironmentService.GetDashboardBoxesSettings(id);
        let boxes = response.data.result.filter(b => b.active);
        boxes.forEach(b => b.count = 0);
        this.boxes = boxes;
      }
    },
    notifyVue(message) {
      // var color = 'info'
      var color = "pz";
      this.$notify({
        message: message,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: color,
        timeout: 1000,
      });
    },
    editCartModalHide() {
      this.shareCartModal = false;
      $("body").css("overflow", "auto");
    },
    deleteCartModalHide() {
      this.deleteCartModal = false;
      $("body").css("overflow", "auto");
    },
    showDeleteCartModal(cartId) {
      $("body").css("overflow", "hidden");
      this.setSelectedCartModel(cartId);
      this.deleteCartModal = true;
    },
    showEditCartModal(cartId) {
      $("body").css("overflow", "hidden");
      this.setSelectedCartModel(cartId);
      this.shareCartModal = true;
    },
    async saveCart() {
      if (!this.cartModel.name || !this.cartModel.expirationDate) return;

      this.cartModel.cartItems = this.$store.state.cart;
      this.cartModel.environmentId = this.$store.state.activeEnvironment.id;

      await CartService.EditCart(this.cartModel);
      this.editCartModalHide();
      this.notifyVue("Cart was saved");

      this.$store.dispatch("loadUserSharedCarts");
    },
    async deleteCart(cartId) {
      await CartService.DeleteCart(cartId);
      this.deleteCartModalHide();
      this.notifyVue("Cart was deleted");

      this.$store.dispatch("loadUserSharedCarts");
    },
    setSelectedCartModel(cartId) {
      let serverCartModel = this.$store.state.mySharedCarts.filter((el) => {
        return el.id === cartId;
      })[0];
      this.cartModel.id = serverCartModel.id;
      this.cartModel.name = serverCartModel.name;
      this.cartModel.message = serverCartModel.message;
      this.cartModel.expirationDate = serverCartModel.expirationDate.slice(
        0,
        10
      );
      this.cartModel.notifyUsers = serverCartModel.notifyUsers;
      this.cartModel.sharedWithUsers = serverCartModel.sharedWithUsers;
    },
  },
};
</script>

<style scoped>
.margin {
  margin-right: 5px !important;
  margin-left: 5px !important;
}

.feedback-text {
  height: 130px;
  width: 100%;
}

.feedback-face {
  margin-right: 3px !important;
  margin-left: 3px !important;
}

.feedback-input {
  width: 90%;
  height: 120px;
  resize: none;
}

.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}

.slide-enter {
  transform: translate(150%, 0);
}

.slide-leave-to {
  transform: translate(150%, 0);
}

.feedback-container {
  border-radius: 3px;
  background-color: white;

  /* display:none; */
  text-align: justify;
  position: absolute;
  right: 0px;
  top: 10%;
  z-index: 9999;
  height: 600px;
  width: 400px;
}

.feedback-button-rotated {
  margin: 10px;
  transform: rotate(90deg);
}

.tab-icon {
  height: 60px;
  width: 60px;
}

.clickable {
  cursor: pointer;
}

.header-text {
  font-size: 13px !important;
  color: #333333 !important;
}

.smaller {
  padding: 0px !important;
}

.larger {
  padding: 13px !important;
}

.slide-box {
  min-height: 250px;
  position: relative;
}

.title-box {
  position: absolute;
  top: 50px;
  left: 100px;
  font-family: "GT Eesti Display Bold", "Didot", "Times New Roman", "serif";
  text-transform: uppercase;
  color: #3c4858;
  background-color: white;
  font-size: 36px;
  padding: 15px;
}

.link-container {
  position: absolute;
  bottom: 100px;
  left: 100px;
}

.link-box {
  font-family: "ProximaNovaSemibold", "Helvetica Neue", "Helvetica", "Arial",
    "sans-serif";
  background: #fff;
  color: #000000;
  font-size: 12px;
  font-weight: 400;

  float: left;
  margin-right: 10px;
  text-transform: uppercase;
  font-weight: 400;
}

.change-pz {
  /* font-size: 1.125em;
  line-height: 1.4em; */
  font-weight: 500;
}

.change-pz a {
  cursor: pointer;
  color: #333333 !important;
}

.change-pz a i {
  font-size: 18px !important;
}
</style>

<style>
.delete-modal>.modal-wrapper>.modal-container {
  max-width: 30% !important;
}
</style>
